import { Component, OnInit, Input, Inject  } from '@angular/core';
import * as $ from 'jquery';
import { NavService } from './header/nav/nav.service';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { APP_CONFIG, AppConfig } from './config/app.config.module';
import * as moment from 'moment-timezone';
import { ISubscription } from 'rxjs/Subscription';
import { SharedService } from './common/shared.service';
import { PortalService } from './services/portal.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: August 14th 2018
 * 
 * Description: Entry components for public portal <gosg-root>.
 **/

@Component({
    selector: 'gosg-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [SafeHtmlPipe]
})
export class AppComponent implements OnInit{
    loader: boolean;
    isSideNav = false;
    isheader:any;
    clientHeight: number;
    title = 'app';
    showLoader: boolean;
    breadcrumb: any;
    txtColor = '#333';
    childData: string;
    translatedText: string;
    supportedLanguages: any[];
    @Input() langChange: string;
    zIndex = '8888';
    zIndex2 = '9999';
    bHeight = '70px';
    bTop = '35px';
    public loading = false;
    public currentDateTime: string;

    
    sidePinNavJSONSubscription: ISubscription;
    chatbotJSONSubscription: ISubscription;
    public sidePinNavJSON: any=[];
    public myflag: any;
    public chatbot: boolean = false;

    constructor(public translate: TranslateService, private activatedRoute: ActivatedRoute, private sharedService: SharedService, private portalService: PortalService, @Inject(APP_CONFIG) private config: AppConfig, public safeHtml: SafeHtmlPipe, public navService: NavService) {
        
        let gaTrackingId = this.config.googleTrackingId;
        let gtagScript = document.createElement("script");
        let scriptUrl = "https://www.googletagmanager.com/gtag/js?id="+gaTrackingId;
        gtagScript.type = "text/javascript";
        gtagScript.setAttribute("async", "true");
        gtagScript.setAttribute("src", scriptUrl);
        //document.documentElement.firstChild.appendChild(gtagScript);
        document.head.insertBefore(gtagScript, document.head.firstElementChild);
        
        let gtagScript2 = document.createElement("script");
        let scriptNode = document.createTextNode("window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());");
        gtagScript2.type = "text/javascript";
        gtagScript2.appendChild(scriptNode);
        document.head.appendChild(gtagScript2);
        console.log('GTag Script loaded');

        this.sharedService.isProtected.next(false);
    
        this.loggedInAutoRedirect();
        this.clientHeight = window.innerHeight - 200;

        //translate.onLangChange.subscribe((event: LangChangeEvent) => {
        //});

        this.loadFEConf(()=> {
            console.log('FE config loaded');
        }); 

        this.sidePinNavJSONSubscription = this.sharedService.sidePinNavJSON.subscribe((data)=> {
           
            if (data && Object.keys(data).length!=0) {
                console.log(data);
                this.sidePinNavJSON = data;
                console.log('sidePinNav data loaded');
              }
        });

        this.chatbotJSONSubscription = this.sharedService.chatBotJSON.subscribe((data)=> {
            if (data && data.active==true) {
               this.chatbot = true;
              /*if(!document.getElementById("chatBotScript")){
                let chatBotScript = document.createElement("script");
                let script = 'var BotStar={appId:"' + data.botid+'",mode:"livechat"};!function(t,a){var e=function(){(e.q=e.q||[]).push(arguments)};e.q=e.q||[],t.BotStarApi=e;!function(){var t=a.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://widget.botstar.com/static/js/widget.js";var e=a.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)}();}(window,document)';
                let scriptNode = document.createTextNode(script);
                chatBotScript.type = "text/javascript";
                chatBotScript.id = "chatBotScript";
                chatBotScript.appendChild(scriptNode);
                document.body.appendChild(chatBotScript);
                console.log('chatbot config loaded');
              }*/
            }
        });
        
        this.activatedRoute.queryParams.subscribe(params => {
            let lng = params['language'];
            if (lng && lng.toLowerCase() == 'my') {
              this.myflag = {language:"my"};
            } else {
              this.myflag = null;
            } 
          });
        
    }

    getExpand(data) {
        if (data || this.navService.digitalTop) {
            this.zIndex = '8888';
            this.zIndex2 = '9999';
            this.bHeight = '70px';
            this.bTop = '35px';
        } else {
            this.zIndex = '8888';
            this.zIndex2 = '9999';
            this.bHeight = '105px';
            this.bTop = '80px';
        }
    }

    showsidenav(data){

        document.getElementById("mySidenav").style.width = "250px";
        this.isSideNav = data;

        if(localStorage.getItem('customFontType')){
            $('#fontOptSideMenu2').val(localStorage.getItem('customFontType'));
        }

        if (localStorage.getItem('themeIndex')) {
            $('#confBar1 .settingBtm input').removeClass('colorPaletteActive');
            $('#confBar1 .settingBtm input:nth('+localStorage.getItem('themeIndex')+')').addClass('colorPaletteActive');
            localStorage.setItem('themeIndex', localStorage.getItem('themeIndex'));
          }

      }

    getTheme() {
        return localStorage.getItem('themeColor');
    }
    ngOnInit() {
        this.currentDateTime = moment().format("YYYY-MM-DD")+ ' 00:00:00';
    }

    loadFEConf(callback) {
        this.portalService.getLocalConfig().subscribe(data => {
          if (data) {
            //this.sharedService.autoLogoutData.next(data.autologout);
            //this.sharedService.sideMenuJSON.next(data.sideMenu);
            this.sharedService.sidePinNavJSON.next(data.sidePinNav);
            this.sharedService.chatBotJSON.next(data.chatbot);
            this.sharedService.searchJSON.next(data.searchsuggest);
            this.sharedService.registerOff.next(data.registeroffline);
            //this.sharedService.uploadLimitData.next(data.limit);
            callback();
          }
         },
         error => {
           console.log(error);
           callback();
         });
      }

    loggedInAutoRedirect() {
        if(this.IsAlreadyLogin()){
          let path = window.location.pathname+window.location.search; 
          console.log('url:'); 
          console.log(path); 
          let protectedURL = path.replace("/portal/", "/portal-protected/");
          //let protectedURL ='/portal-protected/index';
          console.log('AlreadyLogin');
          window.location.href = protectedURL;
        }
    }

    IsAlreadyLogin() {

        if (this.getShibSession()) {
            return true;
        } else {
            return false;
        }
        
    }

    getShibSession() {
        //let cookieName;
        let session;

        let shibcookies = decodeURIComponent(document.cookie).split(';').filter(function(c) {
                    return c.trim().indexOf('_shibsession_') === 0;
                }).map(function(c) {
                    return c.trim();
                });

        console.log(shibcookies);
        if (shibcookies.length > 0) {
            let shibsession = shibcookies[0].split('=');
            if (shibsession.length > 0) {
                //cookieName = shibsession[0]; 
                session = shibsession[1];
            }
            //console.log(cookieName);
            //console.log(session);
        }
        return session;
      }

      closeList(e) {
          console.log({'event':e});
          if(e.target.className === "hover_bkgr_fricc" && this.navService.ispopUpShow && (this.navService.isNavSuggestionList || this.navService.isHomeSearchSuggestionList || this.navService.isSearchSuggestionList)) {
              this.navService.ispopUpShow = false;
              this.navService.isNavSuggestionList = false;
              this.navService.isHomeSearchSuggestionList = false;
              this.navService.isSearchSuggestionList = false;
          }
      }
}







// WEBPACK FOOTER //
// ./src/app/app.component.ts